import axios from '@/http/axios'

export default {
  fetch: (slug, config?) => {
    return axios.get(`/documents/${slug}`, config)
  },
}